export default __webpack_public_path__ + "static/media/037-sydney opera house.3e3c0905.svg";